import { PHONE_REGEX_PATTERN } from '@app/constant/RegexConstant'
import { Translation } from 'react-i18next'
import * as Yup from 'yup'

const EmployeeSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_NAME')}</Translation>),
  phone: Yup.string()
    .trim()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_PHONE')}</Translation>)
    .matches(PHONE_REGEX_PATTERN, {
      message: <Translation>{(t) => t('VALIDATE.VALID_PHONE')}</Translation>,
    }),
  password: Yup.string()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_PASSWORD')}</Translation>)
    .min(6, <Translation>{(t) => t('VALIDATE.VALID_LIMIT_PHONE')}</Translation>),
  pos: Yup.array()
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_POS')}</Translation>)
    .min(1, <Translation>{(t) => t('VALIDATE.VALID_POS', { number: '1' })}</Translation>),
})

export default EmployeeSchema
